import React, { useEffect } from "react";
import { WithKYCInfo } from "@aspen/ui";
import type { TKycInfoV2 } from "@adgm/cross-models";
import { PageKycInformationContentV1 } from "./PageKycInformationContentV1";
import { Breadcrumb } from "antd";
import Link from "next/link";
import { i18nUtil, PROFILE_PATHS } from "@aspen/libs";
import styles from "@aspen/theme/Profile.module.less";
import Image from "next/image";
import { KYC_STATUS } from "@aspen/model";
import ic_get from "@aspen/assets/images/ic_get@2x.png";
import ic_review from "@aspen/assets/images/underview.svg";
import ic_reject from "@aspen/assets/images/reject.svg";
import { PageKycInformationContentV2 } from "./PageKycInformationContentV2";

interface IProps {
  kycInfo: TKycInfoV2;
  getKYCInfo: () => void;
}

const STATUS_TEXT_MAP = {
  Auditing: "kyc.status.under.review",
  Certified: "kyc.certified.text",
  Rejected: "kyc.rejected.text",
};

const STATUS_ICON_MAP = {
  Auditing: ic_review,
  Rejected: ic_reject,
  Certified: ic_get,
};
const Result: React.FC<IProps> = props => {
  const { kycInfo } = props;

  const intl = i18nUtil.t();

  useEffect(() => {
    props.getKYCInfo();
  }, []);

  const statusText = KYC_STATUS[kycInfo.status ?? 1];
  const icon_status = STATUS_ICON_MAP[statusText] ?? ic_get;
  const text_status = intl[STATUS_TEXT_MAP[statusText] ?? "kyc.certified.text"];

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item>{intl["kyc.certify.location"]}:</Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link href={PROFILE_PATHS.PROFILE}>{intl["profile"]}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{intl["kyc.information.title"]}</Breadcrumb.Item>
      </Breadcrumb>
      <div className={styles.kycResult}>
        <p className={styles.title}>{intl["kyc.information.title"]}</p>
        <div className={styles.kycStatus}>
          <span style={{ marginRight: 5 }}>{intl["kyc.status.under.status"]}:</span>
          <Image unoptimized src={icon_status} alt="" width={16} height={16} />
          {kycInfo?.status ? (
            <span
              className={styles[KYC_STATUS[kycInfo.status]?.toLowerCase()]}
              style={{ marginLeft: 5 }}>
              {text_status}
            </span>
          ) : null}
        </div>

         {kycInfo.version === "V2" ? (
          <PageKycInformationContentV2 {...props} />
        ) : (
          <PageKycInformationContentV1 {...props} />
        )}
      </div>
    </>
  );
};

export const PageKycInformation = WithKYCInfo(Result);
